// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
//     this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//     this.setHeaderCartIconAccessibility();
//   }

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector('#cart-icon-bubble');
//     cartLink.setAttribute('role', 'button');
//     cartLink.setAttribute('aria-haspopup', 'dialog');
//     cartLink.addEventListener('click', (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener('keydown', (event) => {
//       if (event.code.toUpperCase() === 'SPACE') {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add('animate', 'active');
//     });

//     this.addEventListener(
//       'transitionend',
//       () => {
//         const containerToTrapFocusOn = this.classList.contains('is-empty')
//           ? this.querySelector('.drawer__inner-empty')
//           : document.getElementById('CartDrawer');
//         const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add('overflow-hidden');
//   }

//   close() {
//     this.classList.remove('active');
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove('overflow-hidden');
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute('role', 'button');
//     cartDrawerNote.setAttribute('aria-expanded', 'false');

//     if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
//       cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
//     }

//     cartDrawerNote.addEventListener('click', (event) => {
//       event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//     });

//     cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') &&
//       this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);
//       sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     });

//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
//   }

//   getSectionInnerHTML(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: 'cart-drawer',
//         selector: '#CartDrawer',
//       },
//       {
//         id: 'cart-icon-bubble',
//       },
//     ];
//   }

//   getSectionDOM(html, selector = '.shopify-section') {
//     return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define('cart-drawer', CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: 'CartDrawer',
//         section: 'cart-drawer',
//         selector: '.drawer__inner',
//       },
//       {
//         id: 'cart-icon-bubble',
//         section: 'cart-icon-bubble',
//         selector: '.shopify-section',
//       },
//     ];
//   }
// }

// customElements.define('cart-drawer-items', CartDrawerItems);

/*
 * cart-drawer.js (self-contained build)
 *
 * Features: quantity +/- + remove, animated reward/progress bar, upsell carousel.
 * - Run-once IIFE so a duplicated <script> include can't redeclare.
 * - All cart writes (quantity change, remove, upsell add) go through ONE serial
 *   queue (cdEnqueue) so they never race each other and can't render a stale/empty
 *   cart.
 * - updateQuantity ignores NaN quantities, so an empty input can never be sent
 *   as quantity:0 (which Shopify interprets as "remove the line").
 */
(function () {
  if (window.__CART_DRAWER_INIT__) return;
  window.__CART_DRAWER_INIT__ = true;

  const CD_ROUTES = {
    change: (window.routes && window.routes.cart_change_url) || '/cart/change',
    add: (window.routes && window.routes.cart_add_url) || '/cart/add',
  };

  /* ------------------------------------------------------ serial write queue */
  /* Guarantees only one cart-mutating request runs at a time. */
  let cdCartBusy = false;
  const cdQueue = [];

  function cdEnqueue(taskFn) {
    cdQueue.push(taskFn);
    cdDrain();
  }

  function cdDrain() {
    if (cdCartBusy) return;
    const task = cdQueue.shift();
    if (!task) return;
    cdCartBusy = true;
    Promise.resolve()
      .then(task)
      .catch((e) => console.error('[cart] write failed', e))
      .finally(() => {
        cdCartBusy = false;
        cdDrain();
      });
  }

  /* ----------------------------------------------------------------- drawer */
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          if (typeof trapFocus === 'function') trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
      animateRewardBar(this);
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
      if (cartDrawerNote.nextElementSibling?.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
      if (typeof onKeyUpEscape === 'function') cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    /* Full replace of #CartDrawer — used by the upsell add-to-cart path. */
    renderContents(parsedState) {
      const inner = this.querySelector('.drawer__inner');
      if (inner?.classList.contains('is-empty')) inner.classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections?.[section.id]) return;
        sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      this.classList.remove('is-empty');
      initUpsellSlider();
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' },
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  /* Shared helper (not tied to any base class). */
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    const node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  /* Animate the reward/progress bar from 0 to its server-rendered target width. */
  function animateRewardBar(root = document) {
    const fill = (root.querySelector ? root : document).querySelector('.cd-bar__fill');
    if (!fill) return;
    const target = fill.style.width || '0%';
    fill.style.width = '0%';
    requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.width = target; }));
  }

  /* --------------------------------------------------- upsell Swiper slider */
  let cdUpsellSwiper = null;

  const CD_UPSELL_SWIPER_OPTS = {
    // grabCursor: true,
    slidesPerView: 1.1,
    spaceBetween: 16,
    speed: 600,
    // freeMode: true,
  };

  function initUpsellSlider() {
    if (cdUpsellSwiper) {
      try { cdUpsellSwiper.destroy(true, true); } catch (e) { /* element already gone */ }
      cdUpsellSwiper = null;
    }

    const el = document.querySelector('.cd_upsell_slider_product');
    if (!el || el.classList.contains('swiper-initialized')) return;

    if (typeof Swiper === 'undefined') {
      if (initUpsellSlider._tries === undefined) initUpsellSlider._tries = 0;
      if (initUpsellSlider._tries++ < 20) setTimeout(initUpsellSlider, 100);
      return;
    }
    initUpsellSlider._tries = 0;
    cdUpsellSwiper = new Swiper(el, CD_UPSELL_SWIPER_OPTS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsellSlider);
  } else {
    initUpsellSlider();
  }

  /* ----------------------------------------------- standalone drawer items */
  class CartDrawerItems extends HTMLElement {
    constructor() {
      super();
      this.pendingInput = null;
      this._commitTimer = null;
      this.addEventListener('click', this.onStepClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }

    disconnectedCallback() {
      // Cancel a pending debounced commit so a replaced row can't fire a stale change.
      clearTimeout(this._commitTimer);
    }

    get lineItemStatusElement() {
      return document.getElementById('CartDrawer-LineItemStatus');
    }

    onStepClick(event) {
      const removeBtn = event.target.closest('.cd-remove-btn');
      if (removeBtn) {
        event.preventDefault();
        this.updateQuantity(removeBtn.dataset.index, 0, removeBtn.dataset.key);
        return;
      }

      const button = event.target.closest('button[name="plus"], button[name="minus"]');
      if (!button) return;
      event.preventDefault();

      const stepper = button.closest('.cd-qty');
      const input = stepper?.querySelector('.cd-qty__input');
      if (!input) return;

      const step = parseInt(input.step, 10) || 1;
      const min = input.min !== '' ? parseInt(input.min, 10) : 0;
      const max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      let value = parseInt(input.value, 10) || 0;

      value = button.name === 'plus' ? value + step : value - step;
      if (value < min) value = min;
      if (value > max) value = max;
      if (value === (parseInt(input.value, 10) || 0)) return;

      input.value = value;
      this.scheduleUpdate(input);
    }

    onChange(event) {
      const input = event.target.closest('.cd-qty__input');
      if (!input) return;
      this.scheduleUpdate(input);
    }

    scheduleUpdate(input) {
      this.pendingInput = input;
      clearTimeout(this._commitTimer);
      this._commitTimer = setTimeout(() => {
        const i = this.pendingInput;
        if (i) this.updateQuantity(i.dataset.index, i.value, i.dataset.key);
      }, 350);
    }

    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    }

    /* Public entry: validate, then enqueue the actual write so it can't race. */
    updateQuantity(line, quantity, key) {
      if (line == null) return;
      const qty = parseInt(quantity, 10);
      if (Number.isNaN(qty) || qty < 0) return; // never send a blank/NaN qty (would remove the line)

      this.enableLoading(line);
      cdEnqueue(() => this._doUpdateQuantity(line, qty, key));
    }

    _doUpdateQuantity(line, qty, key) {
      const body = JSON.stringify({
        [key ? 'id' : 'line']: key || line,
        quantity: qty,
        sections: this.getSectionsToRender().map((s) => s.section),
        sections_url: window.location.pathname,
      });

      return fetch(`${CD_ROUTES.change}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.errors) {
            this.showLineError(line, parsedState.errors);
            return;
          }
          if (parsedState.status) {
            this.showLineError(line, parsedState.description || parsedState.message);
            return;
          }
          this.renderSections(parsedState);
          this.announce(parsedState);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-items', cartData: parsedState });
          }
        })
        .catch(() => {
          this.showCartError();
        })
        .finally(() => {
          this.disableLoading(line);
        });
    }

    renderSections(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !parsedState.sections?.[section.section]) return;
        const target = container.querySelector(section.selector) || container;
        target.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      });

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
        const inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.toggle('is-empty', parsedState.item_count === 0);
      }
      animateRewardBar();
      initUpsellSlider();
    }

    enableLoading(line) {
      document.getElementById('CartDrawer')?.classList.add('cart__items--disabled');
      document.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`).forEach((el) => el.classList.remove('hidden'));
      this.lineItemStatusElement?.setAttribute('aria-hidden', 'false');
      document.activeElement?.blur?.();
    }

    disableLoading() {
      document.getElementById('CartDrawer')?.classList.remove('cart__items--disabled');
    }

    showLineError(line, message) {
      this.disableLoading(line);
      const errorEl = document.getElementById(`CartDrawer-LineItemError-${line}`);
      const textEl = errorEl?.querySelector('.cart-item__error-text');
      if (textEl) textEl.textContent = Array.isArray(message) ? message.join(' ') : message;
    }

    showCartError() {
      this.disableLoading();
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = 'Something went wrong updating your cart. Please try again.';
    }

    announce(parsedState) {
      const live = document.getElementById('CartDrawer-LiveRegionText');
      if (live) live.textContent = `Cart updated. ${parsedState.item_count} items.`;
    }
  }
  if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

  /* --------------------------------------------------- upsell add-to-cart */
  class CartUpsellCard extends HTMLElement {
    constructor() {
      super();
      this.variants = this._readVariants();
      this.selects = Array.from(this.querySelectorAll('.cd-select__input'));
      this.addButton = this.querySelector('.cd-card__add');
      this.priceEl = this.querySelector('[data-upsell-price]');
      this.compareEl = this.querySelector('[data-upsell-compare]');
      this.imageEl = this.querySelector('[data-upsell-image]');
      this.badgeEl = this.querySelector('[data-upsell-badge]');
      this.addLabelEl = this.querySelector('.cd-card__add-label');
      this.addIconEl = this.querySelector('.cd-card__add-icon');
      this.preorderLabels = this._readPreorderLabels();
    }

    connectedCallback() {
      this.selects.forEach((sel) => sel.addEventListener('change', () => this._onOptionChange()));
      this.addButton?.addEventListener('click', () => this._addToCart());
      this._updateSwatches();
    }

    _updateSwatches() {
      this.querySelectorAll('select[data-has-swatch]').forEach((sel) => {
        const opt = sel.options[sel.selectedIndex];
        const color = opt && opt.dataset ? opt.dataset.swatch : '';
        const sw = sel.closest('.cd-select__control')?.querySelector('[data-upsell-swatch]');
        if (sw && color) sw.style.backgroundColor = color;
      });
    }

    _readVariants() {
      try {
        return JSON.parse(this.querySelector('.cd-card__variants').textContent);
      } catch (e) {
        return [];
      }
    }

    _readPreorderLabels() {
      try {
        return JSON.parse(this.addButton?.dataset.preorderLabels || '{}');
      } catch (e) {
        return {};
      }
    }

    _applyPreorderLabel(variant) {
      if (!this.addLabelEl) return;
      const label = variant ? this.preorderLabels[variant.id] : '';

      this.addLabelEl.textContent = label || 'Add';
      if (this.addIconEl) this.addIconEl.hidden = Boolean(label);
      if (this.addButton) this.addButton.setAttribute('aria-label', label || 'Add');
    }

    _selectedVariant() {
      if (!this.selects.length) return this.variants[0];
      const chosen = [];
      this.selects
        .slice()
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .forEach((sel) => {
          chosen[Number(sel.dataset.optionPosition) - 1] = sel.value;
        });
      return this.variants.find((v) => chosen.every((value, i) => v[`option${i + 1}`] === value));
    }

    _formatMoney(cents) {
      const format = this.dataset.moneyFormat || '${{amount}}';
      return format.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }

    _onOptionChange() {
      this._updateSwatches();
      const variant = this._selectedVariant();
      if (!variant) {
        this.addButton?.setAttribute('disabled', 'disabled');
        if (this.addButton) this.addButton.dataset.variantId = '';
        this._applyPreorderLabel(null);
        return;
      }
      this.addButton.dataset.variantId = variant.id;
      variant.available ? this.addButton.removeAttribute('disabled') : this.addButton.setAttribute('disabled', 'disabled');
      this._applyPreorderLabel(variant);

      if (this.priceEl) this.priceEl.textContent = this._formatMoney(variant.price);
      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = this._formatMoney(variant.compare_at_price);
          this.compareEl.hidden = false;
          if (this.badgeEl) {
            const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            this.badgeEl.textContent = `${pct}% OFF`;
            this.badgeEl.hidden = false;
          }
        } else {
          this.compareEl.hidden = true;
          if (this.badgeEl) this.badgeEl.hidden = true;
        }
      }
      if (this.imageEl && variant.featured_image?.src) {
        this.imageEl.src = variant.featured_image.src.replace(/(\.[^.]+)(\?.*)?$/, '_400x$1$2');
      }
    }

    _addToCart() {
      const variantId = this.addButton?.dataset.variantId;
      if (!variantId) return;

      this.addButton.classList.add('is-loading');
      this.addButton.setAttribute('disabled', 'disabled');
      cdEnqueue(() => this._doAdd(variantId));
    }

    _doAdd(variantId) {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartItems = document.querySelector('cart-drawer-items');
      const sections = cartItems
        ? cartItems.getSectionsToRender().map((s) => s.section || s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      return fetch(`${CD_ROUTES.add}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, sections, sections_url: window.location.pathname }),
      })
        .then((response) => response.json())
        .then((parsed) => {
          if (parsed.status) {
            this._showError(parsed.description || parsed.message);
            return;
          }
          if (cartDrawer && parsed.sections) cartDrawer.renderContents(parsed);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell-card', cartData: parsed });
          }
        })
        .catch((err) => {
          this._showError();
          console.error('[cart-upsell] add failed', err);
        })
        .finally(() => {
          this.addButton?.classList.remove('is-loading');
          this.addButton?.removeAttribute('disabled');
        });
    }

    _showError(message) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = message || 'Could not add to cart. Please try again.';
    }
  }
  if (!customElements.get('cart-upsell-card')) customElements.define('cart-upsell-card', CartUpsellCard);
})();